import Reveal from "./Reveal";
import { Music2, Disc3, MapPin } from "lucide-react";

const tiles = [
  { icon: Music2, label: "Hits only" },
  { icon: Disc3, label: "Après Ski" },
  { icon: MapPin, label: "Mitten am Marktplatz" },
];

export default function Konzept() {
  return (
    <section className="py-16 md:py-28" data-testid="section-konzept">
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <Reveal>
          <p className="eyebrow text-brand-dark">
            <span className="eyebrow-rule" aria-hidden="true" />
            Konzept
          </p>
          <h2 className="h2 mt-4">Drinnen wird mitgesungen.</h2>
        </Reveal>
        <Reveal delay={0.08}>
          <p className="mt-5 max-w-[62ch] text-base leading-relaxed md:text-lg">
            Die Hitsstube bringt die OLMA-Nacht ins Waaghaus: Musik, die du kennst,
            eine Tanzfläche voller guter Leute und eine Bar für die nächste Runde.
            Ob du direkt von der Messe kommst oder dich mit deiner Crew am
            Marktplatz triffst – hier beginnt euer gemeinsamer Abend.
          </p>
        </Reveal>
        <div className="mt-10 grid gap-4 sm:grid-cols-3">
          {tiles.map((t, i) => (
            <Reveal key={t.label} delay={i * 0.07} className="h-full">
              <div
                data-testid={`konzept-tile-${i + 1}`}
                className="flex h-full items-center gap-4 rounded-md bg-brand-red p-5 transition-colors duration-200 hover:bg-brand-dark md:p-6"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-paper/15 text-paper">
                  <t.icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <span className="font-display text-base text-paper md:text-lg">
                  {t.label}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
